import React from 'react';
import PropTypes from 'prop-types';

import ATextContainer from '../../atoms/_atoms.text-container';

export default function OHouseHoldStory({
	img,
	title,
	description,
	direction,
	className,
}) {
	const cName = direction === 'reverse' ? 'reverse' : '';

	return (
		<article className={`o-section-household-story ${cName} ${className}`}>
			<figure>
				<img src={img} alt="" />
			</figure>
			<ATextContainer
				title={title}
				description={description}
				className="household-article"
			/>
		</article>
	);
}

OHouseHoldStory.propTypes = {
	img: PropTypes.string.isRequired,
	title: PropTypes.string.isRequired,
	description: PropTypes.string.isRequired,
	direction: PropTypes.string,
	className: PropTypes.string,
};

OHouseHoldStory.defaultProps = {
	direction: 'normal',
	className: '',
};



// WEBPACK FOOTER //
// ./src/components/organisme/house_hold/_organisme.household-story.js